import { AnyAction } from "redux";
import { SdkThunkDispatch } from "./types";

function warn(error: Error): void {
  throw error; // To let the caller handle the rejection
}

export const promise = () => (next: SdkThunkDispatch<any>) => (action: Promise<any> | any): AnyAction =>
  typeof action?.then === "function" ? Promise.resolve(action).then(next, warn) : next(action);
